


export function overrideStyles() {
  let styleElement = document.getElementById('override-labels-styles')
  styleElement = document.createElement('style')
  styleElement.id = 'override-labels-styles'
  document.head.appendChild(styleElement);

  // css
  styleElement.innerText = `
       [role='row']:hover .GroupedActionsButton{
         opacity:1!important;
       }
      `
}

